export const CASUAL_PAGE_CONFIG = {
  "title": "Realtime UA Spend",
  "titleCN": "实时花费",
  "subTitle": "Timezone (UTC{{timeZone}})",
  "subTitleCN": "时区 (UTC{{timeZone}})",
  "path": "/realtime/uaSpend",
  "defaultTab": "overview",
  "tabList": [
    {
      "id": "overview",
      "tabName": "Overview",
      "tabNameCN": "总览",
      "isHaveNotification": true,
      "refresh": true,
      "notificationPath": "/realtime/uaSpend/overview",
      "path": "/realtime/uaSpend",
      "tabIcon": "",
      "logConfig": {
        "pageId": "206801",
        "pageName": "Realtime UA Spend",
        "extInfo": "Realtime UA Spend Overview",
        "pagePath": "/realtime/uaSpend"
      },
      "filters": [
        {
          "name": "RealtimeRevenueFilter",
          "isOpenSticky": false,
          "isHaveFilterSave": true,
          "filterPath": "/realtime/uaSpend",
          "selectorApi": "/api/v1/dashboard/pc/realtime/ua/selector",
          "extraSelectorParams": {
            "system": "bi_realtime_ua_m",
            "data_source": "dashboard"
          },
          "componentList": [
            {
              "name": "MetricInfo",
              "children": [
                {
                  "name": "MetricsCardTitle",
                  "className": "",
                  "type": "view",
                  "style": {},
                  "props": {
                    "config": {
                      "titleEn": "Realtime Key Metrics",
                      "titleCn": "实时关键指标",
                      "isMetricsExplain": false
                    }
                  }
                },
                {
                  "name": "CommonRow",
                  "children": [
                    {
                      "name": "CommonCol",
                      "type": "layout",
                      "props": {
                        "w": 12
                      },
                      "children": [
                        {
                          "name": "realtimeUserService",
                          "className": "dbd-daily-card",
                          "type": "view",
                          "data": {
                            "height": 164
                          },
                          "props": {
                            "config": {
                              "api": "/api/v1/dashboard/pc/realtime/ua/card",
                              "dataKey": "spend",
                              "refreshKey": "realtime_spend",
                              "interval": 300000,
                              "isByDimensionCard": true,
                              "extraParams": {
                                "metrics": [
                                  "spend"
                                ],
                                "interval": 60,
                                "accumulation": {
                                  "custom_accumulation": [
                                    {
                                      "key": "ua_network",
                                      "is_accumulation": true
                                    }
                                  ]
                                }
                              }
                            }
                          },
                          "children": [
                            {
                              "name": "MetricCardCo",
                              "className": "dbd-retention-card",
                              "type": "view",
                              "style": {
                                "marginTop": "0",
                                "minHeight": "240px"
                              },
                              "props": {
                                "config": {
                                  "apiDataKey": "spend"
                                }
                              },
                              "children": [
                                {
                                  "name": "MetricComponent",
                                  "path": "realtime/uaSpend",
                                  "componentKey": "SpendPlatformCard",
                                  "height": 240,
                                  "config": {
                                    "props": {
                                      "dimension": "ua_network",
                                      "isRealTime": true,
                                      "hasChart": false,
                                      "config": {
                                        "dataKey": "{{spend.data}}"
                                      },
                                      "style": {
                                        "minHeight": "240px"
                                      }
                                    }
                                  }
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    },
                    {
                      "name": "CommonCol",
                      "type": "layout",
                      "props": {
                        "w": 12
                      },
                      "children": [
                        {
                          "name": "realtimeUserService",
                          "className": "dbd-daily-card",
                          "type": "view",
                          "data": {
                            "height": 164
                          },
                          "props": {
                            "config": {
                              "api": "/api/v1/dashboard/pc/realtime/ua/card",
                              "dataKey": "install",
                              "refreshKey": "realtime_register",
                              "interval": 300000,
                              "isByDimensionCard": true,
                              "extraParams": {
                                "metrics": [
                                  "install"
                                ],
                                "interval": 5,
                                "accumulation": {
                                  "custom_accumulation": [
                                    {
                                      "key": "ua_network",
                                      "is_accumulation": true
                                    }
                                  ]
                                }
                              }
                            }
                          },
                          "children": [
                            {
                              "name": "MetricCardCo",
                              "className": "dbd-retention-card",
                              "type": "view",
                              "style": {
                                "marginTop": "0",
                                "minHeight": "240px"
                              },
                              "props": {
                                "config": {
                                  "apiDataKey": "install"
                                }
                              },
                              "children": [
                                {
                                  "name": "MetricComponent",
                                  "path": "realtime/uaSpend",
                                  "componentKey": "InstallPlatformCard",
                                  "height": 240,
                                  "config": {
                                    "props": {
                                      "dimension": "ua_network",
                                      "isRealTime": true,
                                      "hasChart": false,
                                      "config": {
                                        "dataKey": "{{install.data}}"
                                      },
                                      "style": {
                                        "minHeight": "240px"
                                      }
                                    }
                                  }
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                {
                  "name": "CommonRow",
                  "className": "margin-t-10",
                  "children": [
                    {
                      "name": "CommonCol",
                      "type": "layout",
                      "props": {
                        "w": 8
                      },
                      "children": [
                        {
                          "name": "realtimeUserService",
                          "className": "dbd-daily-card",
                          "type": "view",
                          "data": {
                            "height": 164
                          },
                          "props": {
                            "config": {
                              "api": "/api/v1/dashboard/pc/realtime/ua/card",
                              "dataKey": "register_organic_per",
                              "refreshKey": "realtime_register_organic_per",
                              "interval": 300000,
                              "extraParams": {
                                "interval": 5,
                                "metrics": [
                                  "register_organic_per"
                                ]
                              }
                            }
                          },
                          "children": [
                            {
                              "name": "MetricCardCo",
                              "className": "dbd-retention-card",
                              "type": "view",
                              "style": {
                                "marginTop": "0"
                              },
                              "props": {
                                "config": {
                                  "apiDataKey": "register_organic_per"
                                }
                              },
                              "children": [
                                {
                                  "name": "MetricsCardContext",
                                  "className": "",
                                  "type": "view",
                                  "style": {},
                                  "props": {
                                    "config": {
                                      "apiDataKey": "register_organic_per",
                                      "metricsName": [
                                        "register_organic_per"
                                      ],
                                      "dataKey": [
                                        "{{register_organic_per.card}}"
                                      ],
                                      "isRealTime": true
                                    }
                                  },
                                  "children": [
                                    {
                                      "name": "MetricComponent",
                                      "path": "realtime/uaSpend",
                                      "componentKey": "RegisterOrganicRateMetricCard",
                                      "className": "dbd-realtime-casual-metric-card",
                                      "height": 164,
                                      "config": {
                                        "props": {
                                          "isRealTime": true,
                                          "isPlaceholderTime": true
                                        }
                                      }
                                    }
                                  ]
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    },
                    {
                      "name": "CommonCol",
                      "type": "layout",
                      "props": {
                        "w": 8
                      },
                      "children": [
                        {
                          "name": "realtimeUserService",
                          "className": "dbd-daily-card",
                          "type": "view",
                          "data": {
                            "height": 164
                          },
                          "props": {
                            "config": {
                              "api": "/api/v1/dashboard/pc/realtime/ua/card",
                              "dataKey": "cpi",
                              "refreshKey": "realtime_cpi",
                              "interval": 300000,
                              "extraParams": {
                                "interval": 60,
                                "metrics": [
                                  "cpi"
                                ]
                              }
                            }
                          },
                          "children": [
                            {
                              "name": "MetricCardCo",
                              "className": "dbd-retention-card",
                              "type": "view",
                              "style": {
                                "marginTop": "0"
                              },
                              "props": {
                                "config": {
                                  "apiDataKey": "cpi"
                                }
                              },
                              "children": [
                                {
                                  "name": "MetricsCardContext",
                                  "className": "",
                                  "type": "view",
                                  "style": {},
                                  "props": {
                                    "config": {
                                      "apiDataKey": "cpi",
                                      "metricsName": [
                                        "cpi"
                                      ],
                                      "dataKey": [
                                        "{{cpi.card}}"
                                      ],
                                      "isRealTime": true
                                    }
                                  },
                                  "children": [
                                    {
                                      "name": "MetricComponent",
                                      "path": "realtime/uaSpend",
                                      "componentKey": "cpiMetricCard",
                                      "className": "dbd-realtime-casual-metric-card",
                                      "height": 164,
                                      "config": {
                                        "props": {
                                          "isRealTime": true,
                                          "isPlaceholderTime": true
                                        }
                                      }
                                    }
                                  ]
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    },
                    {
                      "name": "CommonCol",
                      "type": "layout",
                      "props": {
                        "w": 8
                      },
                      "children": [
                        {
                          "name": "realtimeUserService",
                          "className": "dbd-daily-card",
                          "type": "view",
                          "data": {
                            "height": 164
                          },
                          "props": {
                            "config": {
                              "api": "/api/v1/dashboard/pc/realtime/ua/card",
                              "dataKey": "d1_roas",
                              "refreshKey": "realtime_d1_roas",
                              "interval": 300000,
                              "extraParams": {
                                "interval": 60,
                                "metrics": [
                                  "d1_roas"
                                ]
                              }
                            }
                          },
                          "children": [
                            {
                              "name": "MetricCardCo",
                              "className": "dbd-retention-card",
                              "type": "view",
                              "style": {
                                "marginTop": "0"
                              },
                              "props": {
                                "config": {
                                  "apiDataKey": "d1_roas"
                                }
                              },
                              "children": [
                                {
                                  "name": "MetricsCardContext",
                                  "className": "",
                                  "type": "view",
                                  "style": {},
                                  "props": {
                                    "config": {
                                      "apiDataKey": "d1_roas",
                                      "metricsName": [
                                        "d1_roas"
                                      ],
                                      "dataKey": [
                                        "{{d1_roas.card}}"
                                      ],
                                      "isRealTime": true
                                    }
                                  },
                                  "children": [
                                    {
                                      "name": "MetricComponent",
                                      "path": "realtime/uaSpend",
                                      "componentKey": "roas1MetricCard",
                                      "className": "dbd-realtime-casual-metric-card",
                                      "height": 164,
                                      "config": {
                                        "props": {
                                          "isRealTime": true,
                                          "isPlaceholderTime": true
                                        }
                                      }
                                    }
                                  ]
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                {
                  "name": "realtimeUserService",
                  "className": "",
                  "type": "view",
                  "style": {},
                  "props": {
                    "config": {
                      "api": "/api/v1/dashboard/event_analysis/realtime/date_event_list",
                      "dataKey": "date_event_list",
                      "refreshKey": "realtime_user_event",
                      "interval": 300000
                    }
                  },
                  "children": [
                    {
                      "name": "SegmentScrollCo",
                      "className": "margin-t-20",
                      "style": {},
                      "type": "view",
                      "props": {
                        "config": {
                          "componentSegment": [
                            {
                              "value": "1",
                              "enName": "{{metricsInfo.spend.en}}",
                              "cnName": "{{metricsInfo.spend.cn}}"
                            },
                            {
                              "value": "2",
                              "enName": "{{metricsInfo.realtime_ua_install.en}}",
                              "cnName": "{{metricsInfo.realtime_ua_install.cn}}"
                            },
                            {
                              "value": "3",
                              "enName": "{{metricsInfo.organic_rate.en}}",
                              "cnName": "{{metricsInfo.organic_rate.cn}}"
                            },
                            {
                              "value": "4",
                              "enName": "{{metricsInfo.realtime_cpi.en}}",
                              "cnName": "{{metricsInfo.realtime_cpi.cn}}"
                            },
                            {
                              "value": "5",
                              "enName": "{{metricsInfo.roas1.en}}",
                              "cnName": "{{metricsInfo.roas1.cn}}"
                            }
                          ],
                          "scrollMarginTop": "75px"
                        }
                      },
                      "children": [
                        {
                          "name": "realtimeUserService",
                          "className": "",
                          "type": "view",
                          "style": {
                            "scrollMarginTop": "75px"
                          },
                          "id": 1,
                          "props": {
                            "config": {
                              "api": "/api/v1/dashboard/pc/realtime/ua/trend",
                              "dataKey": "spend",
                              "refreshKey": "realtime_spend",
                              "interval": 300000,
                              "extraParams": {
                                "metrics": [
                                  "spend"
                                ],
                                "interval": 60
                              }
                            }
                          },
                          "children": [
                            {
                              "name": "MetricComponent",
                              "path": "realtime/uaSpend",
                              "componentKey": "SpendRealtimeCard",
                              "config": {}
                            }
                          ]
                        },
                        {
                          "name": "realtimeUserService",
                          "className": "",
                          "type": "view",
                          "style": {
                            "scrollMarginTop": "75px"
                          },
                          "id": 2,
                          "props": {
                            "config": {
                              "api": "/api/v1/dashboard/pc/realtime/ua/trend",
                              "dataKey": "install",
                              "refreshKey": "realtime_register",
                              "interval": 300000,
                              "extraParams": {
                                "metrics": [
                                  "install"
                                ]
                              }
                            }
                          },
                          "children": [
                            {
                              "name": "MetricComponent",
                              "path": "realtime/uaSpend",
                              "componentKey": "InstallRealtimeCard",
                              "config": {}
                            }
                          ]
                        },
                        {
                          "name": "realtimeUserService",
                          "className": "",
                          "type": "view",
                          "style": {
                            "scrollMarginTop": "75px"
                          },
                          "id": 3,
                          "props": {
                            "config": {
                              "api": "/api/v1/dashboard/pc/realtime/ua/trend",
                              "dataKey": "register_organic_per",
                              "refreshKey": "realtime_register_organic_per",
                              "interval": 300000,
                              "extraParams": {
                                "metrics": [
                                  "register_organic_per"
                                ]
                              }
                            }
                          },
                          "children": [
                            {
                              "name": "MetricComponent",
                              "path": "realtime/uaSpend",
                              "componentKey": "RegisterOrganicRateRealtimeCard",
                              "config": {}
                            }
                          ]
                        },
                        {
                          "name": "realtimeUserService",
                          "className": "",
                          "type": "view",
                          "style": {
                            "scrollMarginTop": "75px"
                          },
                          "id": 4,
                          "props": {
                            "config": {
                              "api": "/api/v1/dashboard/pc/realtime/ua/trend",
                              "dataKey": "cpi",
                              "refreshKey": "realtime_cpi",
                              "interval": 300000,
                              "extraParams": {
                                "metrics": [
                                  "cpi"
                                ],
                                "interval": 60
                              }
                            }
                          },
                          "children": [
                            {
                              "name": "MetricComponent",
                              "path": "realtime/uaSpend",
                              "componentKey": "CPIRealtimeCard",
                              "config": {}
                            }
                          ]
                        },
                        {
                          "name": "realtimeUserService",
                          "className": "",
                          "type": "view",
                          "style": {
                            "scrollMarginTop": "75px"
                          },
                          "id": 5,
                          "props": {
                            "config": {
                              "api": "/api/v1/dashboard/pc/realtime/ua/trend",
                              "dataKey": "d1_roas",
                              "refreshKey": "realtime_d1_roas",
                              "interval": 300000,
                              "extraParams": {
                                "metrics": [
                                  "d1_roas"
                                ],
                                "interval": 60
                              }
                            }
                          },
                          "children": [
                            {
                              "name": "MetricComponent",
                              "path": "realtime/uaSpend",
                              "componentKey": "Roas1RealtimeCard",
                              "config": {}
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "id": "byPlatformRegionMediaChannel",
      "tabName": "By Platform/Region/Media Channel",
      "tabNameCN": "分平台/地区/买量渠道",
      "isHaveNotification": true,
      "refresh": true,
      "notificationPath": "/realtime/uaSpend/byPlatformRegionMediaChannel",
      "path": "/realtime/uaSpend/byPlatformRegionMediaChannel",
      "tabIcon": "",
      "logConfig": {
        "pageId": "206802",
        "pageName": "Realtime UA Spend",
        "extInfo": "Realtime UA Spend By Platform/Region/Media Channel",
        "pagePath": "/realtime/uaSpend/byPlatformRegionMediaChannel"
      },
      "filters": [
        {
          "name": "realtimeCountryFilter",
          "isOpenSticky": false,
          "isHaveFilterSave": true,
          "filterPath": "/realtime/uaSpend/byPlatformRegionMediaChannel",
          "selectorApi": "/api/v1/dashboard/pc/realtime/ua/selector",
          "extraSelectorParams": {
            "system": "bi_realtime_ua_m",
            "data_source": "dashboard"
          },
          "componentList": [
            {
              "name": "MetricInfo",
              "children": [
                {
                  "name": "realtimeUserService",
                  "className": "dbd-daily-card",
                  "type": "view",
                  "style": {},
                  "props": {
                    "config": {
                      "api": "/api/v1/dashboard/pc/realtime/ua/dimension/trend",
                      "dataKey": "country_spend",
                      "refreshKey": "realtime_country_spend",
                      "interval": 300000,
                      "extraParams": {
                        "metrics": [
                          "spend"
                        ],
                        "interval": 60
                      }
                    }
                  },
                  "data": {
                    "dataBy": "system"
                  },
                  "children": [
                    {
                      "name": "realtimeUserService",
                      "className": "dbd-daily-card",
                      "type": "view",
                      "style": {},
                      "props": {
                        "config": {
                          "api": "/api/v1/dashboard/pc/realtime/ua/dimension/trend",
                          "dataKey": "country_install",
                          "refreshKey": "realtime_country_register",
                          "interval": 300000,
                          "extraParams": {
                            "metrics": [
                              "install"
                            ]
                          }
                        }
                      },
                      "children": [
                        {
                          "name": "realtimeUserService",
                          "className": "dbd-daily-card",
                          "type": "view",
                          "style": {},
                          "props": {
                            "config": {
                              "api": "/api/v1/dashboard/pc/realtime/ua/dimension/trend",
                              "dataKey": "country_register_organic_per",
                              "refreshKey": "realtime_country_register_organic_per",
                              "interval": 300000,
                              "extraParams": {
                                "metrics": [
                                  "register_organic_per"
                                ]
                              }
                            }
                          },
                          "children": [
                            {
                              "name": "realtimeUserService",
                              "className": "dbd-daily-card",
                              "type": "view",
                              "style": {},
                              "props": {
                                "config": {
                                  "api": "/api/v1/dashboard/pc/realtime/ua/dimension/trend",
                                  "dataKey": "country_cpi",
                                  "refreshKey": "realtime_country_cpi",
                                  "interval": 300000,
                                  "extraParams": {
                                    "metrics": [
                                      "cpi"
                                    ],
                                    "interval": 60
                                  }
                                }
                              },
                              "children": [
                                {
                                  "name": "realtimeUserService",
                                  "className": "dbd-daily-card",
                                  "type": "view",
                                  "style": {},
                                  "props": {
                                    "config": {
                                      "api": "/api/v1/dashboard/pc/realtime/ua/dimension/trend",
                                      "dataKey": "country_d1_roas",
                                      "refreshKey": "realtime_country_d1_roas",
                                      "interval": 300000,
                                      "extraParams": {
                                        "metrics": [
                                          "d1_roas"
                                        ],
                                        "interval": 60
                                      }
                                    }
                                  },
                                  "children": [
                                    {
                                      "name": "ScrollBodyCo",
                                      "className": "margin-t-20",
                                      "style": {},
                                      "type": "view",
                                      "props": {
                                        "config": {
                                          "dataKey": "dataBy",
                                          "componentSegment": [
                                            {
                                              "value": "1",
                                              "enName": "{{metricsInfo.spend.en}}",
                                              "cnName": "{{metricsInfo.spend.cn}}"
                                            },
                                            {
                                              "value": "2",
                                              "enName": "{{metricsInfo.realtime_ua_install.en}}",
                                              "cnName": "{{metricsInfo.realtime_ua_install.cn}}"
                                            },
                                            {
                                              "value": "3",
                                              "enName": "{{metricsInfo.organic_rate.en}}",
                                              "cnName": "{{metricsInfo.organic_rate.cn}}"
                                            },
                                            {
                                              "value": "4",
                                              "enName": "{{metricsInfo.realtime_cpi.en}}",
                                              "cnName": "{{metricsInfo.realtime_cpi.cn}}"
                                            },
                                            {
                                              "value": "5",
                                              "enName": "{{metricsInfo.roas1.en}}",
                                              "cnName": "{{metricsInfo.roas1.cn}}"
                                            }
                                          ],
                                          "scrollMarginTop": "75px"
                                        }
                                      },
                                      "children": [
                                        {
                                          "name": "MetricComponent",
                                          "path": "realtime/uaSpend",
                                          "componentKey": "SpendByDimensionCard",
                                          "id": 1,
                                          "config": {}
                                        },
                                        {
                                          "name": "MetricComponent",
                                          "path": "realtime/uaSpend",
                                          "componentKey": "InstallByDimensionCard",
                                          "id": 2,
                                          "config": {}
                                        },
                                        {
                                          "name": "MetricComponent",
                                          "path": "realtime/uaSpend",
                                          "componentKey": "RegisterOrganicRateByDimensionCard",
                                          "id": 3,
                                          "config": {}
                                        },
                                        {
                                          "name": "MetricComponent",
                                          "path": "realtime/uaSpend",
                                          "componentKey": "CPIByDimensionCard",
                                          "id": 4,
                                          "config": {}
                                        },
                                        {
                                          "name": "MetricComponent",
                                          "path": "realtime/uaSpend",
                                          "componentKey": "Roas1ByDimensionCard",
                                          "id": 5,
                                          "config": {}
                                        }
                                      ]
                                    }
                                  ]
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};